import React, { useEffect, useRef, useState } from 'react';
import { ConnectInfoDto } from '../models/connect-info-dto';
import httpService from '../api/HttpService';
import { Player } from '../models/player';
import { Button, Form, Modal } from 'react-bootstrap';
import cuescoreService from '../api/CuescoreService';

interface Props {
    onPlayerFound?: (player: Player) => void;
    text?: string;
}

const FindPlayer: React.FC<Props> = (props: Props) => {

    const { onPlayerFound, text } = props;

    const [showModal, setShowModal] = useState(false);

    const playerFound = (player: Player) => {
        console.log("Found player!", player);
        onPlayerFound && onPlayerFound(player);
    }

    return (
        <div>
            <p>{ text ? text : "Find player"}</p>
            <Button variant="primary" onClick={() => setShowModal(true)}>
                Find
            </Button>
            <FindPlayerModal show={showModal} onClose={() => setShowModal(false)} onPlayerClick={playerFound} />
        </div>
    );
}

interface CookieProps {
    onPlayerClick?: (player: Player) => void;
    onClose?: () => void;
    show: boolean;
}

const CookieModal: React.FC<CookieProps> = (props: CookieProps) => {
    const { show, onPlayerClick, onClose } = props;

    return (
        <>
            {
                props.show &&
                <Modal show={props.show} onHide={props.onClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Search for player</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Form>
                            <Form.Group controlId="formBasicText">
                                <Form.Label>Search with cuescore id, DDBU license number, short id or with name</Form.Label>

                            </Form.Group>

                        </Form>


                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={props.onClose}>
                            Accept
                        </Button>
                        <Button variant="secondary" onClick={props.onClose}>
                            Decline
                        </Button>
                    </Modal.Footer>
                </Modal>
            }
        </>
    );
}

interface ModalProps {
    onPlayerClick?: (player: Player) => void;
    onClose?: () => void;
    show: boolean;
}

const FindPlayerModal: React.FC<ModalProps> = (props: ModalProps) => {
    const { show, onPlayerClick, onClose } = props;
    const [nameInput, setNameInput] = useState('');
    const [players, setPlayers] = useState<Player[]>();

    // Add a ref for the input
    const inputRef = useRef<HTMLInputElement>(null);

    // Focus the input when the modal is shown
    useEffect(() => {
        if (show && inputRef.current) {
            inputRef.current.focus();
        }
    }, [show]);

    // useEffect that searches for in api/players with input as the search string
    useEffect(() => {
        if (!nameInput) {
            return;
        }

        if ((!nameInput || nameInput.length <= 2)) {
            setPlayers([]);
            return;
        }

        const fetchConnectInfo = async () => {
            const response = await httpService.get<Player[]>(`api/players?name=${nameInput}`);
            setPlayers(response);
        };

        fetchConnectInfo();

    }, [nameInput]);

    const playerClick = async (player: Player) => {
        onPlayerClick && onPlayerClick(player);
    }

    const goToCreatePlayer = () => {
        window.location.href = `/create-player`;
    }

    return (
        <>
            {
                props.show &&
                <Modal show={props.show} onHide={props.onClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Search for player</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Form>
                            <Form.Group controlId="formBasicText">
                                <Form.Label>Search with cuescore id, DDBU license number, short id or with name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="username"
                                    placeholder="Search"
                                    value={nameInput}
                                    onChange={e => setNameInput(e.target.value)}
                                    ref={inputRef} // <-- attach the ref here
                                />
                            </Form.Group>
                            {players ?
                                <div>
                                    {players.length} players found
                                    <ul className='list-unstyled'>
                                        {players.map(x => {

                                            return (
                                                <li key={x.id} className='player-item' onClick={() => playerClick(x)}>
                                                    <div>
                                                        {x.firstName.trim()}&nbsp;{x.lastName.trim()}
                                                    </div>
                                                    {x.altId &&
                                                        <img src='cuescore-logo.png' height={'34px'} title='Player is linked to cuescore'></img>
                                                    }
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                                :
                                <div>No results</div>
                            }
                        </Form>
                        <hr></hr>
                        <div>
                            <p>Can't find yourself? Create your player profile here:</p>
                            <Button variant="secondary" onClick={goToCreatePlayer}>
                                Create player profile
                            </Button>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={props.onClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
            }
        </>
    );
}

export default FindPlayer;